export const GET_PAYMENT_BEGIN = 'GET_PAYMENT_BEGIN'
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS'
export const GET_PAYMENT_FAILURE = 'GET_PAYMENT_FAILURE'

export const SET_FILTER_PAYMENT_BEGIN = 'SET_FILTER_PAYMENT_BEGIN'
export const SET_FILTER_PAYMENT_SUCCESS = 'SET_FILTER_PAYMENT_SUCCESS'

export const CLEAN_FILTER_PAYMENT_SUCCESS = 'CLEAN_FILTER_PAYMENT_SUCCESS'

export const ADD_PAYMENT_BEGIN = 'ADD_PAYMENT_BEGIN'
export const ADD_PAYMENT_SUCCESS = 'ADD_PAYMENT_SUCCESS'
export const ADD_PAYMENT_FAILURE = 'ADD_PAYMENT_FAILURE'


export const GO_TO_PAYMENTS_ADMINISTRATOR_BEGIN = 'GO_TO_PAYMENTS_ADMINISTRATOR_BEGIN'
export const GO_TO_PAYMENTS_ADMINISTRATOR_SUCCESS = 'GO_TO_PAYMENTS_ADMINISTRATOR_SUCCESS'
export const GO_TO_PAYMENTS_ADMINISTRATOR_FAILURE = 'GO_TO_PAYMENTS_ADMINISTRATOR_FAILURE'

export const CONTINUE_PAYMENT_BEGIN = 'CONTINUE_PAYMENT_BEGIN'
export const CONTINUE_PAYMENT_SUCCESS = 'CONTINUE_PAYMENT_SUCCESS'
export const CONTINUE_PAYMENT_FAILURE = 'CONTINUE_PAYMENT_FAILURE'

export const CLEAR_ULT_PAYMENT = 'CLEAR_ULT_PAYMENT'
export const CLEAR_URL_ADMINISTRATOR = 'CLEAR_URL_ADMINISTRATOR'

export const CLEAR_ERROR_MESSAGE_PAYMENT = 'CLEAR_ERROR_MESSAGE_PAYMENT'